var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section footer"},[(_vm.config && _vm.config.template && _vm.config.template == 'climate_kick')?_c('CKick'):_c('Standard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }